export interface NewUserAccountEmailVerificationRequestModel {
  email: string;
  verificationCode: string;
}
